import { render, staticRenderFns } from "./deposit-list-member.vue?vue&type=template&id=a6c27740&scoped=true&"
import script from "./deposit-list-member.vue?vue&type=script&lang=js&"
export * from "./deposit-list-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c27740",
  null
  
)

export default component.exports